import { Avatar, AvatarProps } from '@mui/material';
import { networkImages } from './NetworkImage';

interface AvatarNetworkProps extends AvatarProps {
  network: string | null | undefined;
}

export function AvatarNetwork({ network, ...props }: AvatarNetworkProps) {
  const src = network ? networkImages[network] : undefined;

  return (
    <Avatar
      src={src}
      alt={network ?? ' '}
      {...props}
      sx={[
        src
          ? {
              background: 'none',
            }
          : {
              background: null,
            },
      ]}
    >
      {network ? (network.length > 3 ? network[0] : network) : ' '}
    </Avatar>
  );
}
